import { render, staticRenderFns } from "./PrfOrdersProjection.vue?vue&type=template&id=36900e08"
import script from "./PrfOrdersProjection.vue?vue&type=script&lang=js"
export * from "./PrfOrdersProjection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports